export const billingInfoConstants = {
  BILLING_INFO_REQUEST: "BILLING_INFO_REQUEST",
  BILLING_INFO_SUCCESS: "BILLING_INFO_SUCCESS",
  BILLING_INFO_FAILURE: "BILLING_INFO_FAILURE",
  BILLING_INFO_RESET: "BILLING_INFO_RESET",
};
